<template>
  <div>
    <v-toolbar
      :flat="!hideItems"
      app
      v-scroll="onScroll"
      v-resize="onResize"
      :style="isTransparent ? 'background-color: transparent;': 'background-color: white;'"
    >
      <v-toolbar-side-icon
        color="primary"
        @click="drawer = !drawer"
        v-show="hideItems"
      ></v-toolbar-side-icon>
      <v-spacer v-show="hideItems"></v-spacer>
      <router-link :to="{name: 'Welcome'}">
        <img
          style="max-height: 75px; max-width: 75px"
          :src="require('@/assets/logo.png')"
          v-show="hideItems"
        />
      </router-link>
      <router-link :to="{name: 'Welcome'}">
        <img
          style="margin-top: 10px;"
          :src="require('@/assets/logo.png')"
          v-show="!hideItems"
        />
      </router-link>
      <v-spacer></v-spacer>
      <SocialMedia v-show="!hideItems" />

      <v-btn
        color="primary"
        href="tel:+13103601360"
      >
        <v-icon left>phone</v-icon>
        (310) 360-1360
      </v-btn>

      <template
        v-slot:extension
        v-if="!hideItems"
      >
        <v-spacer></v-spacer>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn
            flat
            color="primary"
          >Procedures</v-btn>
          <v-btn
            flat
            color="primary"
          >Rodeo Skin Spa</v-btn>
          <v-btn
            flat
            color="primary"
          >Before & After Photos</v-btn>
          <v-btn
            flat
            color="primary"
          >Patient Reviews</v-btn>
          <v-btn
            flat
            color="primary"
          >About</v-btn>
          <v-btn
            flat
            color="primary"
          >Contact</v-btn>
        </v-toolbar-items>
      </template>

    </v-toolbar>
    <v-navigation-drawer
      v-if="hideItems"
      v-model="drawer"
      class="primary lighten-1"
      app
      dark
    >
      <v-container
        grid-list-md
        text-xs-center
      >
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-list
              dense
              class="pt-0"
            >
              <v-list-tile
                v-for="link in links"
                :key="link.title"
              >
                <v-list-tile-action>
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ link.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  components: {
    SocialMedia: () => import('@/components/SocialMedia')
  },

  data: () => ({
    isTransparent: true,
    hideItems: false,
    drawer: false,
    links: [
      { title: 'Procedures', path: '/procedures', icon: 'dashboard' },
      { title: 'Rodeo Skin Spa', path: '/rodeo-skin-spa', icon: 'dashboard' },
      { title: 'Before & After Photos', path: '/before-after', icon: 'dashboard' },
      { title: 'Patient Reviews', path: '/patient-reviews', icon: 'dashboard' },
      { title: 'Contact', path: '/contact', icon: 'dashboard' }
    ]
  }),
  mounted () {
    this.onResize()
    this.onScroll()
  },

  methods: {
    onScroll () {
      this.isTransparent = window.pageYOffset < 200 && this.hideItems === false
    },
    onResize () {
      this.hideItems = window.innerWidth < 960
    }
  }
}
</script>
